import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const BookingPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <Link 
            to="/"
            className="inline-flex items-center space-x-2 text-gray-600 hover:text-teal-600 transition-colors duration-300 group"
          >
            <ArrowLeft className="w-5 h-5 group-hover:-translate-x-1 transition-transform duration-300" />
            <span>Back to Home</span>
          </Link>
          <h1 className="text-4xl font-serif text-gray-800 mt-4">Book Your Appointment</h1>
          <p className="text-gray-600 mt-2">Schedule your massage or facial session with Ayumi Suzuki</p>
        </div>
      </div>

      {/* Acuity Scheduling Embed */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="bg-white rounded-lg shadow-lg overflow-hidden">
          <iframe 
            src="https://ayumisuzukicom.as.me/schedule/a8f9fe2f" 
            width="100%" 
            height="800" 
            frameBorder="0"
            title="Book an Appointment with Ayumi Suzuki"
            className="w-full"
            style={{ minHeight: '800px' }}
          ></iframe>
        </div>
        
        {/* Helper Text */}
        <div className="mt-6 text-center text-gray-600">
          <p className="text-sm">Having trouble booking? <a href="https://ayumisuzukicom.as.me/schedule/a8f9fe2f" target="_blank" rel="noopener noreferrer" className="text-teal-600 hover:text-teal-700 underline">Open scheduler in new window</a></p>
        </div>
      </div>
    </div>
  );
};

export default BookingPage;